import React from "react";
import { StyledLabel } from './Label.styles';

interface LabelProps {
    text: string;
}

export const Label = (props: LabelProps) => {
    return (
        <StyledLabel>
            {props.text}
        </StyledLabel>
    );
}